import axios from "axios";
import authHeader from "../auth/auth-header";
import services from "@/config/services";
import Cookies from "js-cookie";

/**
 * Servizio Fix PdC (Gestione PdC > Fix). Uno o più XML di risposta SII (flusso 0100):
 *  - POST /management/pdc/fix/preview  analizza, nessun effetto collaterale
 *  - POST /management/pdc/fix/upload   esegue il fix (backfill _out + CSV in uscita)
 * Entrambe rispondono con { risultati: [un esito per file], totali, avviso }.
 */
export default class GestionePdcFixService {
  constructor() {
    this.baseUrl = `${services.ask_pratiche_api.url}`;

    axios.interceptors.request.use((req) => {
      req.headers["Authorization"] = authHeader();
      req.headers["Params"] =
        Cookies.get("google_access_token") || Cookies.get("ask_access_token");
      return req;
    });
  }

  /** 'totale_selezionati' fa accorgere il backend se il server ne ha scartati per il suo limite. */
  _formData(files) {
    const list = Array.isArray(files) ? files : [files];
    const fd = new FormData();
    list.forEach((f) => fd.append("files[]", f));
    fd.append("totale_selezionati", String(list.length));
    return fd;
  }

  async preview(files) {
    const url = `${this.baseUrl}/management/pdc/fix/preview`;
    const response = await axios.post(url, this._formData(files));
    return response.data;
  }

  async upload(files) {
    const url = `${this.baseUrl}/management/pdc/fix/upload`;
    const response = await axios.post(url, this._formData(files));
    return response.data;
  }
}
